module.exports = __webpack_public_path__ + "static/media/airbnb-logo.eab230a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/airbnb-logo.png
// module id = 1017
// module chunks = 0